import ScalableDocumentList from '@containers/scalable-document-list';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';

const reviewRowClassName = 'document-review-row';
export const DocumentReviewList = styled(ScalableDocumentList).attrs(props => ({
    classes: {
        row: reviewRowClassName
    }
}))`
  .${reviewRowClassName} {
    margin-bottom: 0px;
  }
`;

export const Instruction = styled.span`
  font-weight: bold;
  /* TODO: change to Roboto or other sans-serif font */
  font-family: sans-serif;
`;

export const ButtonSubtitle = styled.span`
   margin-left: auto;
   margin-right: auto;
   max-width: 280px;
   font-size: ${() => themeProvider.getTypography().font.size.small};
   display: block;
   text-align: center;
`;

export const ContainingImage = styled.img`
  object-fit: contain;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/styles.tsx